import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Zoom from '@material-ui/core/Zoom';
import parse from 'html-react-parser';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: (props) => ({
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: props.maxWidth || 350,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  }),
}))(({ maxWidth, ...props }) => <Tooltip {...props} />);

const defaultChild = (cursor, icon, iconColor) => {
  return (
    <span style={{ cursor: cursor, color: iconColor }}>
      <i className={`wb ${drapcodeIcon(icon)}`}></i>
    </span>
  );
};

const appendDefaultChild = (cursor, icon, iconColor) => {
  return (
    <div className="input-group-append">
      <span className="input-group-text">
        <span style={{ cursor: cursor, color: iconColor }}>
          <i className={`wb ${drapcodeIcon(icon)}`}></i>
        </span>
      </span>
    </div>
  );
};

const TooltipInfo = ({
  icon = 'description',
  headerText,
  title,
  prefix,
  cursor = 'default',
  isHtml = true,
  showArrow = false,
  showHeader = false,
  append = false,
  iconColor = 'inherit',
  maxWidth = 350,
  children,
}) => {
  const defaultTitleHeader = headerText ? headerText : `What's this?`;
  return (
    <>
      {prefix}
      <HtmlTooltip
        title={
          <React.Fragment>
            <Typography
              color="inherit"
              style={{ marginBottom: '10px', marginTop: '10px', padding: '5px' }}
            >
              {showHeader && defaultTitleHeader}
            </Typography>
            {showHeader && <hr />}
            <div
              className="MuiTypography-root MuiTypography-body2 MuiTypography-colorInherit"
              style={{ marginBottom: '10px', padding: '0 5px', fontSize: '' }}
            >
              {isHtml && title ? parse(title) : title}
            </div>
          </React.Fragment>
        }
        TransitionComponent={Zoom}
        disableFocusListener
        arrow={showArrow}
        maxWidth={maxWidth}
      >
        {children
          ? children
          : append
          ? appendDefaultChild(cursor, icon, iconColor)
          : defaultChild(cursor, icon, iconColor)}
      </HtmlTooltip>
    </>
  );
};

export default TooltipInfo;
